import { createContext, useContext, ReactElement } from 'react';

interface DrawerContextType {
  openDrawer: (content: ReactElement) => void;
  changeDrawerContent: (content: ReactElement) => void;
  closeDrawer: () => void;
  isOpen: boolean;
}

export const DrawerContext = createContext<DrawerContextType | null>(null);

export const useDrawer = (): DrawerContextType => {
  const context = useContext(DrawerContext);
  if (!context) {
    throw new Error('useDrawer must be used within a DrawerProvider');
  }
  return context;
};
